<button (click)="openCreate()" class="btn btn-primary-outline add-button">Add</button>
<h4>Store Requirements</h4>

@if (requirements().length > 0) {
  <div>
    <p class="extra-time">
      Make sure there are enough staff available {{ getExtraTime() }} minutes before store opening time and
      after store closing time.
    </p>
  </div>
}

<strong class="table-title">Min. Employees</strong>
@if (requirements().length > 0) {
  <app-sortable-table [headers]="headers" class="requirements-table">
    @for (requirement of requirements(); track requirement) {
      <tr>
        <td>{{ requirement.minimumOpeningEmployees }}</td>
        <td>{{ requirement.minimumRegularEmployees }}</td>
        <td>{{ requirement.minimumClosingEmployees }}</td>
        <td>{{ requirement.startDate | dateParse | dateFormat: 'ddd, D MMM YYYY' }}</td>
        <td>
          @if (canEditAtDate(requirement.startDate)) {
            <i
                    (click)="openUpdate(requirement)"
                    class="fa fa-xs fa-pen pointer me-1">
            </i>
          }
          @if (canEditAtDate(requirement.startDate)) {
            <i
                    (click)="openDelete(requirement.startDate)"
                    class="fa fa-xs fa-trash pointer">
            </i>
          }
        </td>
      </tr>
    }
  </app-sortable-table>
}